import { toast } from "sonner";
import QRCode from "qrcode";
import { withSigner } from "../components/Letterhead";

export const SIG_DEFAULT = 140;
export const STAMP_DEFAULT = 190;

// Inline SVG QR (sync) pointing at the public verification page.
export const verifyQR = (id, size = 92) => {
  if (!id) return "";
  const url = `${window.location.origin}/verify/${id}`;
  const q = QRCode.create(url, { errorCorrectionLevel: "M" });
  const n = q.modules.size, d = q.modules.data;
  let p = "";
  for (let y = 0; y < n; y++) for (let x = 0; x < n; x++) if (d[y * n + x]) p += `M${x + 2} ${y + 2}h1v1h-1z`;
  return `<div style="text-align:center;font-size:9px;color:#64748b"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${n + 4} ${n + 4}" width="${size}" height="${size}" shape-rendering="crispEdges"><rect width="100%" height="100%" fill="#fff"/><path d="${p}" fill="#0f172a"/></svg><div>امسح للتحقق</div></div>`;
};

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

// Opens a printable (Save as PDF) decision on the company letterhead with official + employee signatures.
// urlFor(fileId) builds an authorised image URL (admin /files or /portal/files).
const decisionHTML = (d, company, urlFor, autoPrint) => {
  const c = withSigner(company || {}, d);
  const img = (id, style) => (id ? `<img src="${urlFor(id)}" crossorigin="anonymous" style="${style}"/>` : "");
  const meta = [c.cr_number && `س.ت: ${esc(c.cr_number)}`, c.vat_number && `الرقم الضريبي: ${esc(c.vat_number)}`, c.phone && esc(c.phone), c.address && esc(c.address)].filter(Boolean).join(" · ");
  const empSig = d.signature_id
    ? `${img(d.signature_id, "height:120px;object-fit:contain")}<div class="small">وُقّع إلكترونياً ${esc((d.signed_at || "").slice(0, 16).replace("T", " "))}</div>
       ${d.biometric_verified ? `<div class="bio">✔ تم التحقق ببصمة الجهاز (${esc(d.biometric_device || "")})</div>` : ""}`
    : `<div class="line"></div><div class="small">التوقيع والبصمة</div>`;
  return (`<!doctype html><html dir="rtl" lang="ar"><head><style>@font-face{font-family:SaudiRiyal;src:url(/fonts/riyal.woff2) format("woff2");unicode-range:U+20C1}</style><meta charset="utf-8"/><title>${d.kind === "letter" ? "" : "قرار "}${esc(d.number || "")} - ${esc(d.title)}</title>
  <style>
    @page{size:A4;margin:14mm}
    body{font-family:SaudiRiyal,"Tajawal","Segoe UI",Tahoma,sans-serif;color:#0f172a;margin:0}
    .head{display:flex;justify-content:space-between;align-items:center;border-bottom:3px double #1e293b;padding-bottom:10px}
    .head h1{margin:0;font-size:20px}.head .en{font-size:12px;color:#64748b;direction:ltr}.head .meta{font-size:11px;color:#64748b;margin-top:4px}
    .ref{display:flex;justify-content:space-between;font-size:13px;margin:14px 0;color:#334155}
    .title{text-align:center;font-size:20px;font-weight:800;margin:10px 0 18px;text-decoration:underline;text-underline-offset:6px}
    .body{font-size:15px;line-height:2.1}.body ol,.body ul{padding-right:22px}
    .sigs{display:flex;justify-content:space-between;gap:24px;margin-top:40px;page-break-inside:avoid}
    .sig{flex:1;text-align:center}.sig h4{margin:0 0 8px;font-size:14px}
    .line{height:70px;border-bottom:1px solid #94a3b8;margin:0 20px}.small{font-size:11px;color:#64748b;margin-top:4px}
    .bio{font-size:11px;color:#047857;margin-top:4px;font-weight:700}
    .foot{margin-top:30px;border-top:1px solid #e2e8f0;padding-top:6px;font-size:10px;color:#94a3b8;text-align:center}
  </style></head><body>
  <div class="head"><div><h1>${esc(c.name || "")}</h1>${c.name_en ? `<div class="en">${esc(c.name_en)}</div>` : ""}<div class="meta">${meta}</div></div>
  ${img(c.logo_id, "height:70px;width:70px;object-fit:contain")}</div>
  <div class="ref"><span>${d.kind === "letter" ? "الرقم" : "رقم القرار"}: <b>${esc(d.number || "—")}</b></span><span>التاريخ: <b>${esc(d.date || "")}</b></span></div>
  <div class="title">${esc(d.title)}</div>
  <div class="body">${d.body_html || ""}</div>
  ${d.kind === "letter" && !d.show_stamp ? "" : `<div class="sigs">
    ${d.kind === "letter" ? "<div class=\"sig\"></div>" : `<div class="sig"><h4>الموظف: ${esc(d.employee_name || "")}</h4>${empSig}</div>`}
    <div class="sig"><h4>${esc(c.official_title || "المدير العام")}${c.official_name ? `: ${esc(c.official_name)}` : ""}</h4>
      ${c.signature_id ? img(c.signature_id, `height:${c.sig_size || SIG_DEFAULT}px;max-width:340px;object-fit:contain`) : `<div class="line"></div>`}
      ${img(c.stamp_id, `height:${c.stamp_size || STAMP_DEFAULT}px;max-width:340px;object-fit:contain;margin-top:6px`)}</div>
  </div>`}
  <div class="foot" style="display:flex;align-items:center;justify-content:space-between;gap:12px;text-align:right"><span>صدر إلكترونياً عبر WorkZone — ${esc(d.number || "")}</span>${d.id ? verifyQR(d.id) : ""}</div>
  ${autoPrint ? "<script>window.onload=()=>setTimeout(()=>window.print(),600)</script>" : ""}</body></html>`);
};

export const printDecision = (d, company = {}, urlFor) => {
  const w = window.open("", "_blank");
  if (!w) { toast.error("اسمح بالنوافذ المنبثقة لحفظ القرار PDF"); return; }
  w.document.write(decisionHTML(d, company, urlFor, true));
  w.document.close();
};

// Renders the decision offscreen and returns an A4 PDF Blob.
export const decisionPDFBlob = (d, company = {}, urlFor) => htmlPDFBlob(decisionHTML(d, company, urlFor, false));

// html2canvas draws list markers on the left; render them as inline text so RTL lists number from the right
export const fixRtlLists = (doc) => {
  doc.querySelectorAll("ol, ul").forEach((list) => {
    const ol = list.tagName === "OL", start = Number(list.getAttribute("start")) || 1;
    list.style.listStyle = "none";
    [...list.children].filter((li) => li.tagName === "LI").forEach((li, i) => {
      const m = doc.createElement("span");
      m.textContent = ol ? `${start + i}. ` : "• ";
      m.style.cssText = "display:inline-block;min-width:1.4em;margin-inline-end:4px;font-weight:600";
      li.insertBefore(m, li.firstChild);
    });
  });
};

export const htmlPDFBlob = async (html) => {
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([import("html2canvas"), import("jspdf")]);
  const f = document.createElement("iframe");
  f.style.cssText = "position:fixed;left:-10000px;top:0;width:794px;height:1123px;border:0";
  document.body.appendChild(f);
  try {
    f.contentDocument.open(); f.contentDocument.write(html); f.contentDocument.close();
    const doc = f.contentDocument, body = doc.body;
    document.querySelectorAll('link[rel="stylesheet"][href*="fonts.googleapis"]').forEach((l) => { const n = doc.createElement("link"); n.rel = "stylesheet"; n.href = l.href; doc.head.appendChild(n); });
    const st = doc.createElement("style"); st.textContent = 'body{font-family:SaudiRiyal,"IBM Plex Sans Arabic",Tahoma,sans-serif!important;padding:40px}'; doc.head.appendChild(st);
    await new Promise((r) => setTimeout(r, 300));
    try { await doc.fonts.ready; } catch { /* ignore */ }
    for (let i = 0; i < 50 && [...f.contentDocument.images].some((im) => !im.complete); i++) await new Promise((r) => setTimeout(r, 100));
    await new Promise((r) => setTimeout(r, 300));
    fixRtlLists(doc);
    const canvas = await html2canvas(body, { scale: 2, useCORS: true, backgroundColor: "#ffffff", windowWidth: 794 });
    const pdf = new jsPDF({ unit: "mm", format: "a4" });
    const pxPerMm = canvas.width / 210, pageH = Math.floor(297 * pxPerMm);
    for (let y = 0, i = 0; y < canvas.height; y += pageH, i++) {
      if (i && canvas.height - y < pageH * 0.04) break;
      const c = document.createElement("canvas"); c.width = canvas.width; c.height = Math.min(pageH, canvas.height - y);
      c.getContext("2d").drawImage(canvas, 0, y, canvas.width, c.height, 0, 0, canvas.width, c.height);
      if (i) pdf.addPage();
      pdf.addImage(c.toDataURL("image/jpeg", 0.9), "JPEG", 0, 0, 210, c.height / pxPerMm);
    }
    return pdf.output("blob");
  } finally { f.remove(); }
};
